import { Externalautomation } from 'data/firestore/agent/externalautomation/types';
import { EntityGet } from 'data/firestore/types';
import useManageExternalAutomations from 'data/hooks/useManageExternalAutomations';
import { useParams } from 'react-router-dom';
import ButtonIcon from 'components/ButtonIcon';
import Pencil from 'components/icons/pencil2';
import Trash from 'components/icons/trash';
import { ActionsCellWrapper } from './styled';
import { ADD_EDIT_EXTERNAL_AUTOMATION_DRAWER } from '../../../../constants';

interface Props {
    row?: EntityGet<Externalautomation>;
}

const ActionsColumn = ({ row }: Props) => {
    const { agentId = '' } = useParams<{ agentId?: string }>();
    const {
        edit,
        remove,
    } = useManageExternalAutomations({
        agentId,
        modalId: ADD_EDIT_EXTERNAL_AUTOMATION_DRAWER,
    });

    if (!row) {
        return null;
    }

    return (
        <ActionsCellWrapper>
            <ButtonIcon
                borderRadius="semi-square"
                icon={<Pencil />}
                tooltip="Edit external automation"
                size="small"
                onClick={() => edit(row)}
            />
            <ButtonIcon
                borderRadius="semi-square"
                icon={<Trash />}
                tooltip="Remove external automation"
                size="small"
                onClick={() => remove(row.id)}
            />
        </ActionsCellWrapper>
    );
};

export default ActionsColumn;
